









import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class Button extends Vue {
	@Prop({ default: 'button' }) readonly type!: string
	@Prop({ default: 'blue' }) readonly color!: string
	@Prop({ default: 'button' }) readonly tag!: string
	@Prop({ default: false }) readonly disabled!: boolean
	@Prop({ default: false }) readonly hollow!: boolean
	@Prop({ default: false }) readonly big!: boolean
	@Prop({ default: true }) readonly minWidth!: boolean
	@Prop({ default: false }) readonly circle!: boolean
	@Prop({ default: false }) readonly fullwidth!: boolean
	@Prop({ default: ' ' }) readonly extraClass!: string
	
	get btnClasses () {
		if (this.circle) {
			return [
				`inline-flex items-center justify-center transition-all duration-300 whitespace-no-wrap bg-beige-300 text-btn text-white rounded-full ${this.big ? 'w-e36 h-e36': 'w-e26 h-e26 font-20'}`,
				this.disabled ? 'pointer-events-none bg-opacity-50' : '',
			]
		} else {
			return [
				`btn relative leading-none transition-all duration-300 whitespace-no-wrap inline-flex items-center justify-center text-btn ${this.extraClass}`,
				this.hollow ? '' : `bg-${this.color}`,
				this.hollow ? `text-${this.color}` : 'text-white',
				this.hollow ? `` : 'shadow-md',
				this.minWidth && !this.fullwidth ? 'min-w-btn' : '',
				this.fullwidth ? 'w-full' : '',
				this.disabled ? 'pointer-events-none bg-opacity-50 border-opacity-50' : '',
				`border-${this.color}`,
				...this.spacingClasses,
				...this.fontClasses
			]
		}
	}

	get spacingClasses () {
		return [
			this.big ? 'px-e60' : 'px-e34',
			this.big ? 'h-e50' : 'h-e40',
			this.big ? 'text-btn' : 'text-btn-sm',
		]
	}

	get fontClasses () {
		return [
			this.hollow ? 'font-normal' : 'font-bold'
		]
	}
}
